
const digest = 'b3d358f2c6df7d5dd5a54162013758c33f3b475c304974523826e20192b00185';
const classes = {"wrapper":"_wrapper_1vi5m_1","closeButton":"_closeButton_1vi5m_9"};
const css = `._wrapper_1vi5m_1 {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
}

._closeButton_1vi5m_9 {
  position: absolute;
  right: 0;
  top: 0;
  padding: 13px;
  z-index: 1;
  flex-shrink: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  